import { CSSProperties, ReactNode } from 'react';
import { Avatar, Typography } from '@mui/material';

export interface LogoProps {
  logoUrl?: string;
  width?: number | string;
  height?: number | string;
  representativeChar?: string;
  svgImage?: ReactNode;
  sx?: CSSProperties;
  imagePosition?: string;
}

export const Logo = ({
  logoUrl,
  width = 'auto',
  height = 60,
  representativeChar = '-',
  svgImage,
  sx,
  imagePosition = 'center',
}: LogoProps) => (
  <Avatar
    src={logoUrl}
    variant="rounded"
    sx={{
      width,
      height,
      overflow: 'visible',
      backgroundColor: logoUrl ? 'transparent' : (theme) => theme.palette.grey[600],
      '& .MuiAvatar-img': {
        width,
        height: '100%',
        objectFit: 'contain',
        objectPosition: imagePosition,
      },
      '& svg': {
        objectFit: 'contain',
        objectPosition: imagePosition,
      },
      ...sx,
    }}
  >
    {logoUrl?.includes('.svg') && svgImage ? svgImage : <Typography variant="h4">{representativeChar}</Typography>}
  </Avatar>
);
